import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestArgumentTypes } from '@src/app/shared/types/common';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  /**
   * @description Generic method for making API call to apiUrl coming from server configs
   * @param {string} method - get, post, put
   * @param {string} endpoint
   * @param {Object} body - Request body
   * @param {Object} headers - Request body
   * @param {Object} params - Request parameters
   * @param {string} requestFormat - Sending request's format, can be either 'form' or 'json'. Default is 'json'
   * @param {string} responseType - Response's format, can be either 'text' or 'json'. Default is 'json'
   * @param {string} transferCache - Allow cache from server side rendering'
   */
  request({
    method,
    endpoint,
    body,
    params,
    requestFormat,
    responseType,
    headers,
    transferCache = true,
  }: RequestArgumentTypes): Observable<any> {
    const URL = environment.apiUrl + endpoint;
    const httpHeaders = new HttpHeaders({
      ...headers,
    });

    const isBodyAllowed = !['get', 'head'].includes(method.toLowerCase());

    if (!isBodyAllowed && body != null) {
      console.warn(
        `[ApiService] Body ignored for ${method.toUpperCase()} ${URL}`,
        body,
      );
    }

    let httpParams = new HttpParams();
    if (params && Object.keys(params).length) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, params[key]);
      });
    }

    const formData = new FormData();

    if (body && Object.keys(body).length) {
      Object.keys(body).forEach((key) => {
        if (Array.isArray(body[key])) {
          for (let x = 0; x < body[key].length; x++) {
            formData.append(key, body[key][x]);
          }
        } else {
          formData.append(key, body[key]);
        }
      });
    }

    const requestOptions: any = {
      params: httpParams,
      responseType: responseType || 'json',
      transferCache,
    };

    requestOptions.headers = httpHeaders;

    if (isBodyAllowed) {
      requestOptions.body = requestFormat === 'form' ? formData : body;
    }

    return this.http.request(method, URL, requestOptions);
  }
}
